"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_INTEGER_FORMAT = exports.DEFAULT_PERCENTAGE_FORMAT = exports.DEFAULT_DECIMAL_FORMAT = void 0;
// (C) 2020 GoodData Corporation
exports.DEFAULT_DECIMAL_FORMAT = "#,##0.00";
exports.DEFAULT_PERCENTAGE_FORMAT = "#,##0.00%";
exports.DEFAULT_INTEGER_FORMAT = "#,##0";
//# sourceMappingURL=constants.js.map